import { Component } from '@angular/core';
import { HotjarService } from './services/hotjar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Admed';
  constructor(private hotjarService: HotjarService) {}
}
